angular.module('impactx.basket').controller('CateringDialogCtrl', CateringDialogCtrl);

CateringDialogCtrl.$inject = ['$scope', 'dataGen', 'TranslationService', '$mdDialog', 'bkiId'];

function CateringDialogCtrl($scope, dataGen, TranslationService, $mdDialog, bkiId) {
    var ctrl = this;

    $scope.minDate = new Date();

    ctrl.participantsEntryPoint = '/basket/cateringparticipants';

    ctrl.addParticipant = function () {
        $scope.data.participants.push({selected: {value: null}});
    }

    ctrl.removeParticipant = function (index) {
        $scope.data.participants.splice(index, 1);
    }

    ctrl.participantSearchTextChange = function (index, selected, searchText) {
        if (!$scope.data.participants[index].freeSelection) {
            $scope.data.participants[index].freeSelection = {value: null};
        }
        if (!selected) {
            $scope.data.participants[index].freeSelection.value = searchText;
        }
        else {
            $scope.data.participants[index].freeSelection.value = null;
        }
    };

    ctrl.participantSelect = function (index, selected, baseObject, searchText) {
        if (!$scope.data.participants[index].freeSelection) {
            $scope.data.participants[index].freeSelection = {value: null};
        }
        if (!selected) {
            $scope.data.participants[index].freeSelection.value = searchText;
        }
        else {
            $scope.data.participants[index].freeSelection.value = null;
        }
    };

    ctrl.getData = function () {
        var paramObj = {
            bkiId: bkiId
        };
        dataGen.getData($scope, paramObj, '/basket/editcatering').then(function () {
            if($scope.data.participants.length === 0) {
                ctrl.addParticipant();
            }
        });
    };

    ctrl.save = function () {
        var paramObj = {
            cateringData: $scope.data
        };
        dataGen.postAsForm({}, paramObj, '/basket/savecatering').then(function () {
            $mdDialog.hide();
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

    ctrl.getData();
}